var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "shortcutComponent",
    {
      ref: "shortCutComponent",
      attrs: {
        btOkName: "Buscar",
        modalClass: "lm-h-flex-modal",
        showAddNew: false,
      },
      on: { "selection-item": _vm.onBuscarAtendimento },
    },
    [
      _c(
        "div",
        { attrs: { slot: "component" }, slot: "component" },
        [
          _c("div", { attrs: { slot: "rows" }, slot: "rows" }, [
            _c("form", [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-sm-6" }, [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "tooltip",
                          rawName: "v-tooltip",
                          value: _vm.errors.first("dataInicial"),
                          expression: "errors.first('dataInicial')",
                        },
                      ],
                      staticClass: "form-group",
                    },
                    [
                      _c(
                        "label",
                        {
                          staticClass: "control-label",
                          attrs: { for: "dataInicial" },
                        },
                        [
                          _c("span", { staticStyle: { color: "red" } }, [
                            _vm._v("*"),
                          ]),
                          _vm._v(
                            "\n                                " +
                              _vm._s(
                                _vm.$t(
                                  "__.Crud.downloadXmls.edit_vue_html.dataInicial"
                                )
                              ) +
                              "\n                            "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c("dateTimePickerComponent", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "'required'",
                          },
                        ],
                        attrs: { id: "dataInicial", name: "dataInicial" },
                        model: {
                          value: _vm.dataInicial,
                          callback: function ($$v) {
                            _vm.dataInicial = $$v
                          },
                          expression: "dataInicial",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-sm-6" }, [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "tooltip",
                          rawName: "v-tooltip",
                          value: _vm.errors.first("dataFinal"),
                          expression: "errors.first('dataFinal')",
                        },
                      ],
                      staticClass: "form-group",
                    },
                    [
                      _c(
                        "label",
                        {
                          staticClass: "control-label",
                          attrs: { for: "dataFinal" },
                        },
                        [
                          _c("span", { staticStyle: { color: "red" } }, [
                            _vm._v("*"),
                          ]),
                          _vm._v(
                            "\n                                " +
                              _vm._s(
                                _vm.$t(
                                  "__.Crud.downloadXmls.edit_vue_html.dataFinal"
                                )
                              ) +
                              "\n                            "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c("dateTimePickerComponent", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "'required'",
                          },
                        ],
                        attrs: { id: "dataFinal", name: "dataFinal" },
                        model: {
                          value: _vm.dataFinal,
                          callback: function ($$v) {
                            _vm.dataFinal = $$v
                          },
                          expression: "dataFinal",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-sm-12" }, [
                  _c(
                    "div",
                    { staticClass: "form-group" },
                    [
                      _c(
                        "label",
                        {
                          staticClass: "control-label",
                          attrs: { for: "usuarioId" },
                        },
                        [
                          _vm._v(
                            "\n                                " +
                              _vm._s(
                                _vm.$t(
                                  "__.Components.parent.atendimento.trocarAtendente.nomeAtendente"
                                )
                              ) +
                              "\n                            "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c("combo-component", {
                        attrs: {
                          id: "usuarioId",
                          name: "usuarioId",
                          data: _vm.usuariosOptions,
                          searchable: true,
                        },
                        model: {
                          value: _vm.usuarioId,
                          callback: function ($$v) {
                            _vm.usuarioId = $$v
                          },
                          expression: "usuarioId",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-sm-12" }, [
                  _c("div", { staticClass: "form-group" }, [
                    _c(
                      "label",
                      {
                        staticClass: "control-label",
                        attrs: { for: "usuarioId" },
                      },
                      [
                        _vm._v(
                          "\n                                " +
                            _vm._s(_vm.$t("__.Crud.pcp.pesquisar")) +
                            "\n                            "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.filterKey,
                          expression: "filterKey",
                        },
                      ],
                      staticClass: "form-control",
                      attrs: {
                        autocomplete: "off",
                        type: "text",
                        id: "id",
                        name: "id",
                        placeholder:
                          "Pesquise pelo nome ou telefone de contato",
                      },
                      domProps: { value: _vm.filterKey },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.filterKey = $event.target.value
                        },
                      },
                    }),
                  ]),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _vm.gridData.length > 0
              ? _c(
                  "div",
                  { staticClass: "col-sm-12" },
                  [
                    _c("grid-component", {
                      attrs: {
                        data: _vm.gridData,
                        columns: _vm.gridColumns,
                        "show-edit-item": false,
                        "show-remove-item": false,
                        "show-table-head": false,
                        "show-table-foot": false,
                        extraActions: _vm.extraActions,
                      },
                      on: { "extra-action": _vm.onExtraAction },
                    }),
                  ],
                  1
                )
              : _vm._e(),
          ]),
          _vm._v(" "),
          _c("historicoAtendimentoMensagens", {
            ref: "historicoAtendimentoMensagens",
          }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }